"use client";

import { useTranslations } from "next-intl";
import Link from "next/link";
import logo from "@/assets/images/logos/logo.svg";
import Image from "next/image";
import { socials } from "@/data/socials";
import { motion } from "framer-motion";

export const Footer = () => {
  const t = useTranslations("footer");
  const currentYear = new Date().getFullYear();

  // Variants pour les animations
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: "easeOut",
      },
    },
  };

  const logoVariants = {
    hidden: {
      opacity: 0,
      scale: 0.9,
    },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  return (
    <footer className="px-4 pb-48 ph:px-24 md:px-36 lg:px-48 xl:px-60">
      <motion.div
        initial={{ width: 0 }}
        whileInView={{ width: "100%" }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true, margin: "-50px" }}
        className="w-full border-t border-tertiary"
      ></motion.div>

      <motion.div
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-50px" }}
        className="flex w-full flex-col items-start justify-between gap-12 py-[16px] lg:flex-row lg:items-center"
      >
        <motion.div variants={itemVariants} className="flex flex-1 flex-col">
          <p className="text-accent">Copyright © {currentYear} Virtuosa.</p>
          <div className="flex flex-col xl:flex-row xl:gap-2">
            <Link
              href="/mentions-legales"
              className="text-sm text-accent hover:text-secondary"
            >
              {t("links.legalNotice")}
            </Link>
            <Link
              href="/cookies"
              className="text-sm text-accent hover:text-secondary"
            >
              {t("links.cookies")}
            </Link>
          </div>
        </motion.div>

        <motion.div
          variants={logoVariants}
          className="flex flex-1 justify-center md:mr-[3.5rem]"
        >
          <Link href="/">
            <Image src={logo} alt={t("alt.logo")} />
          </Link>
        </motion.div>

        <motion.div
          variants={itemVariants}
          className="flex flex-1 justify-end gap-4"
        >
          {socials.map((social) => (
            <Link href={social.url} key={social.name} target="_blank">
              <p className="text-accent hover:text-secondary">{social.name}</p>
            </Link>
          ))}
        </motion.div>
      </motion.div>
    </footer>
  );
};
